import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { API } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = location.hash || window.location.hash;
      const params = new URLSearchParams(hash.replace(/^#/, ""));
      const sid = params.get("session_id");
      if (!sid) { nav("/login"); return; }
      try {
        await axios.post(`${API}/auth/google/session`, { session_id: sid });
        // clear hash
        window.history.replaceState({}, document.title, "/calendar");
        await checkAuth();
        toast.success("Signed in with Google!");
        nav("/calendar");
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-muted-foreground text-sm font-mono">Signing you in…</div>
    </div>
  );
}
